import React from "react";

import useGlobalConfirm from "Hooks/UseGlobalConfirm";

import Button from "Components/Global/Buttons";

import * as S from "./styles";

const GlobalConfirm = () => {
  const { confirmProps, removeGlobalConfirm } = useGlobalConfirm();

  return (
    <S.Modal open={!!confirmProps}>
      <S.Background
        onClick={() =>
          confirmProps?.closeOnClickBackground && removeGlobalConfirm()
        }
      />
      <S.ModalWrapper type={confirmProps?.type}>
        <S.Header type={confirmProps?.type}>
          <S.Title>{confirmProps?.title}</S.Title>
        </S.Header>
        {confirmProps?.message && <S.Text>{confirmProps?.message}</S.Text>}
        <S.Buttons>
          {confirmProps?.confirmText && (
            <Button
              variant={confirmProps?.type}
              onClick={() => {
                confirmProps?.onClickConfirm && confirmProps.onClickConfirm();
                removeGlobalConfirm();
              }}
              outline
              text={confirmProps?.confirmText}
            />
          )}
          {confirmProps?.denyText && (
            <Button
              variant={confirmProps?.type}
              onClick={() => {
                confirmProps?.onClickDeny && confirmProps.onClickDeny();
                removeGlobalConfirm();
              }}
              text={confirmProps?.denyText}
            />
          )}
        </S.Buttons>
      </S.ModalWrapper>
    </S.Modal>
  );
};

export default GlobalConfirm;
